// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"edb6f376","453":"97650fe8","455":"8cff3459"}[chunkId] + ".chunk.js";
};